document.addEventListener('DOMContentLoaded', function () {
  const bundleRoot = document.getElementById('ed-bundle-main');
  const popupRoot = document.querySelector('.ed-popup-bundle');

  if (!bundleRoot) return;

  const state = {
    currentVariantId: null,
    currentVariant: null,
    variantData: null,
    productCache: {},
    bundleItems: {
      first: createInitialBundleItemState('first'),
      second: createInitialBundleItemState('second')
    }
  };

  const els = {
    mainFirstImage: document.getElementById('bundle-image-1st-product'),
    mainSecondImage: document.querySelector('.bundle-image-2nd-product'),
    mainTitles: document.querySelectorAll('.ed-product-wrapper .product-title'),
    popupAtcButton: popupRoot ? popupRoot.querySelector('[data-bundle-atc]') : null,
    popupStatus: popupRoot ? popupRoot.querySelector('#ed-bundle-status-message') : null,
    popupCloseButton: popupRoot ? popupRoot.querySelector('[data-bundle-popup-close]') : null,
    popupOpenButton: document.getElementById('ed-bundle-popup-button')
  };

  injectBundleEnhancementStyles();
  bindPopupOpenCloseEvents();
  bindPopupAtc();
  bindPopupOptionEvents();
  bindVariantChangeListener();
  initializeFromCurrentPage();

  function createInitialBundleItemState(slot) {
    return {
      slot,
      product: null,
      selectedVariantId: null,
      selectedOptions: {},
      productHandle: null,
      mountedCard: null,
      elements: null,
      config: {
        title: '',
        subtitle: '',
        customImage: ''
      }
    };
  }

  function bindVariantChangeListener() {
    document.addEventListener('variant:change', function (event) {
      const variant = event?.detail?.variant;
      if (!variant || !variant.id) return;

      state.currentVariantId = String(variant.id);
      state.currentVariant = variant;
      state.variantData = getVariantData(variant.id);

      if (!state.variantData) {
        bundleRoot.classList.add('bundle-hide');
        resetPopupContentToUnavailable('This bundle is not available for the selected product variant.');
        return;
      }

      bundleRoot.classList.remove('bundle-hide');
      updateMainBundleContent(state.variantData);
      updatePopupForVariant(state.variantData);
    });
  }

  function initializeFromCurrentPage() {
    const selectedVariantIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!selectedVariantIdInput?.value) return;

    const initialVariantId = selectedVariantIdInput.value;
    const variantData = getVariantData(initialVariantId);

    if (!variantData) {
      bundleRoot.classList.add('bundle-hide');
      resetPopupContentToUnavailable('This bundle is not available for the selected product variant.');
      return;
    }

    state.currentVariantId = String(initialVariantId);
    state.currentVariant = getCurrentMainVariantObject(initialVariantId);
    state.variantData = variantData;

    bundleRoot.classList.remove('bundle-hide');
    updateMainBundleContent(variantData);
    updatePopupForVariant(variantData);
  }

  function getVariantData(variantId) {
    if (typeof window.variantMetafield === 'undefined' || !window.variantMetafield) return null;
    return window.variantMetafield[String(variantId)] || window.variantMetafield[variantId] || null;
  }

  function getCurrentMainVariantObject(variantId) {
    if (window.product && Array.isArray(window.product.variants)) {
      const found = window.product.variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });

      if (found) return found;
    }

    return {
      id: variantId,
      option1: getSelectedOptionValue(['option1', 'option[Color]', 'Color']),
      option2: getSelectedOptionValue(['option2', 'option[Size]', 'Size']),
      option3: getSelectedOptionValue(['option3'])
    };
  }

  function getSelectedOptionValue(possibleNames) {
    for (const name of possibleNames) {
      const checkedRadio = document.querySelector(`input[name="${cssEscape(name)}"]:checked`);
      if (checkedRadio?.value) return checkedRadio.value;

      const select = document.querySelector(`select[name="${cssEscape(name)}"]`);
      if (select?.value) return select.value;
    }

    return null;
  }

  function updateMainBundleContent(variantData) {
    if (!variantData) return;

    if (els.mainFirstImage && variantData.firstProductImage) {
      els.mainFirstImage.src = variantData.firstProductImage;
      els.mainFirstImage.srcset = variantData.firstProductImage;
    }

    if (els.mainSecondImage && variantData.secondProductImage) {
      els.mainSecondImage.src = variantData.secondProductImage;
      els.mainSecondImage.srcset = variantData.secondProductImage;
    }

    if (els.mainTitles[0] && variantData.firstProductTitle) {
      els.mainTitles[0].textContent = variantData.firstProductTitle;
    }

    if (els.mainTitles[1] && variantData.secondProductTitle) {
      els.mainTitles[1].textContent = variantData.secondProductTitle;
    }
  }

  function updatePopupForVariant(variantData) {
    if (!popupRoot) return;

    if (!variantData) {
      resetPopupContentToUnavailable('This bundle is not available for the selected product variant.');
      return;
    }

    const firstHandle = variantData.firstProductVariants;
    const secondHandle = variantData.secondProductVariants;

    if (!firstHandle || !secondHandle) {
      resetPopupContentToUnavailable('This bundle is not available for the selected variant.');
      return;
    }

    Promise.all([fetchProductData(firstHandle), fetchProductData(secondHandle)])
      .then(function ([firstProduct, secondProduct]) {
        mountBundleProduct('first', firstProduct, {
          title: variantData.firstProductTitle,
          subtitle: variantData.firstProductColor,
          customImage: variantData.firstProductImage
        });

        mountBundleProduct('second', secondProduct, {
          title: variantData.secondProductTitle,
          subtitle: variantData.secondProductColor,
          customImage: variantData.secondProductImage
        });

        validateBundleState();
      })
      .catch(function (error) {
        console.error('Error fetching bundle products:', error);
        resetPopupContentToUnavailable('Bundle items could not be loaded right now.');
      });
  }

  function fetchProductData(productHandle) {
    if (!productHandle) {
      return Promise.reject(new Error('Missing product handle'));
    }

    if (state.productCache[productHandle]) {
      return Promise.resolve(state.productCache[productHandle]);
    }

    return fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product not found: ' + productHandle);
        }
        return response.json();
      })
      .then(function (product) {
        state.productCache[productHandle] = product;
        return product;
      });
  }

  function mountBundleProduct(slot, product, config) {
    const itemState = state.bundleItems[slot];
    const card = popupRoot.querySelector(`[data-bundle-slot="${slot}"]`);
    if (!card) return;

    itemState.product = product;
    itemState.productHandle = product?.handle || null;
    itemState.mountedCard = card;
    itemState.config = config;
    itemState.elements = getCardElements(card);

    const preferredVariant = getPreferredInitialVariant(product);

    itemState.selectedOptions = preferredVariant
      ? getSelectedOptionsFromVariant(product, preferredVariant)
      : createEmptySelectedOptions(product);

    itemState.selectedVariantId = preferredVariant ? String(preferredVariant.id) : null;

    renderBundleProductCard(itemState);
  }

  function getCardElements(card) {
    return {
      titleEl: card.querySelector('[data-bundle-product-title]'),
      subTitleEl: card.querySelector('[data-bundle-product-subtitle]'),
      imageEl: card.querySelector('[data-bundle-product-image]'),
      linkEl: card.querySelector('[data-bundle-product-link]'),
      priceEl: card.querySelector('[data-bundle-price]'),
      compareEl: card.querySelector('[data-bundle-compare-price]'),
      optionsTarget: card.querySelector('[data-bundle-options]')
    };
  }

  function getPreferredInitialVariant(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      return null;
    }

    if (state.currentVariant) {
      const exactSameVariant = product.variants.find(function (variant) {
        return String(variant.id) === String(state.currentVariant.id) && variant.available;
      });

      if (exactSameVariant) return exactSameVariant;

      const preferredOptions = {
        1: state.currentVariant.option1 || '',
        2: state.currentVariant.option2 || '',
        3: state.currentVariant.option3 || ''
      };

      const exactOptionMatch = product.variants.find(function (variant) {
        if (!variant.available) return false;

        return product.options.every(function (_optionName, index) {
          const position = index + 1;
          const preferredValue = preferredOptions[position];
          if (!preferredValue) return true;
          return String(variant[`option${position}`] || '') === String(preferredValue);
        });
      });

      if (exactOptionMatch) return exactOptionMatch;

      const closestMatch = findClosestAvailableVariant(product, preferredOptions);
      if (closestMatch) return closestMatch;
    }

    return getFirstAvailableVariant(product);
  }

  function renderBundleProductCard(itemState) {
    const { product, config, elements } = itemState;
    const {
      titleEl,
      subTitleEl,
      imageEl,
      linkEl,
      priceEl,
      compareEl,
      optionsTarget
    } = elements;

    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) {
      if (titleEl) titleEl.textContent = config.title || '';
      if (subTitleEl) subTitleEl.textContent = config.subtitle || '';
      setPriceContent(priceEl, compareEl, null);
      setNoVariantState(optionsTarget, 'This item has no variants available.');
      setBundleItemImage(imageEl, null, config.customImage, product);
      itemState.selectedVariantId = null;
      return;
    }

    const resolvedVariant = resolveVariantFromSelectedOptions(product, itemState.selectedOptions);
    const selectedVariant = resolvedVariant || getFirstAvailableVariant(product) || null;

    if (selectedVariant) {
      itemState.selectedVariantId = String(selectedVariant.id);
      itemState.selectedOptions = getSelectedOptionsFromVariant(product, selectedVariant);
    } else {
      itemState.selectedVariantId = null;
    }

    if (titleEl) titleEl.textContent = config.title || product.title || '';
    if (subTitleEl) subTitleEl.textContent = buildVariantSubTitle(product, selectedVariant, config.subtitle);
    if (linkEl) linkEl.href = product.url || '#';

    setBundleItemImage(imageEl, selectedVariant, config.customImage, product);
    setPriceContent(priceEl, compareEl, selectedVariant);
    renderAllOptionGroups(optionsTarget, itemState.slot, product, itemState.selectedOptions);
  }

  function renderAllOptionGroups(target, slot, product, selectedOptions) {
    if (!target) return;

    target.innerHTML = '';

    if (!product || !Array.isArray(product.options) || !product.options.length) {
      setNoVariantState(target, 'This item has no configurable options.');
      return;
    }

    for (let optionIndex = 0; optionIndex < product.options.length; optionIndex += 1) {
      const optionName = getProductOptionName(product, optionIndex);
      const optionPosition = optionIndex + 1;
      const values = getUniqueOptionValues(product, optionPosition);

      const group = document.createElement('div');
      group.className = 'ed-bundle-option-group';
      group.setAttribute('data-bundle-option-group', '');

      const label = document.createElement('div');
      label.className = 'form__label';
      label.textContent = optionName + ':';
      group.appendChild(label);

      const valuesWrap = document.createElement('div');
      valuesWrap.className = 'ed-bundle-option-values';

      values.forEach(function (value) {
        const isSelectable = isOptionValueSelectable(product, selectedOptions, optionPosition, value);
        const isChecked = String(selectedOptions[optionPosition] || '') === String(value);
        const optionId = `bundle-${slot}-option-${optionPosition}-${slugify(value)}`;

        const optionWrap = document.createElement('div');
        optionWrap.className = `ed-variant-option ${isSelectable ? '' : 'is-disabled'}`;

        const input = document.createElement('input');
        input.type = 'radio';
        input.id = optionId;
        input.name = `bundle-${slot}-option-${optionPosition}`;
        input.value = value;
        input.checked = isChecked;
        input.disabled = !isSelectable;
        input.setAttribute('data-bundle-slot', slot);
        input.setAttribute('data-option-position', String(optionPosition));
        input.setAttribute('data-option-value', value);

        const labelEl = document.createElement('label');
        labelEl.setAttribute('for', optionId);
        labelEl.textContent = value;

        optionWrap.appendChild(input);
        optionWrap.appendChild(labelEl);
        valuesWrap.appendChild(optionWrap);
      });

      group.appendChild(valuesWrap);
      target.appendChild(group);
    }

    const resolvedVariant = resolveVariantFromSelectedOptions(product, selectedOptions);

    if (!resolvedVariant) {
      setNoVariantInlineMessage(target, 'One selected combination is unavailable.');
      return;
    }

    if (!resolvedVariant.available) {
      setNoVariantInlineMessage(target, 'This selected variant is sold out.');
    }
  }

  function getProductOptionName(product, optionIndex) {
    if (!product || !Array.isArray(product.options)) return `Option ${optionIndex + 1}`;

    const option = product.options[optionIndex];
    if (typeof option === 'string') return option;
    if (option && typeof option.name === 'string') return option.name;

    return `Option ${optionIndex + 1}`;
  }

  function getUniqueOptionValues(product, optionPosition) {
    const key = `option${optionPosition}`;
    const result = [];

    (product.variants || []).forEach(function (variant) {
      const value = variant[key];
      if (value == null || value === '') return;

      const normalized = String(value);
      if (!result.includes(normalized)) {
        result.push(normalized);
      }
    });

    return result;
  }

  function getFirstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;

    return product.variants.find(function (variant) {
      return !!variant.available;
    }) || null;
  }

  function getSelectedOptionsFromVariant(product, variant) {
    const selected = {};
    if (!product || !Array.isArray(product.options) || !variant) return selected;

    product.options.forEach(function (_optionName, index) {
      const position = index + 1;
      selected[position] = variant[`option${position}`] != null ? String(variant[`option${position}`]) : '';
    });

    return selected;
  }

  function createEmptySelectedOptions(product) {
    const selected = {};
    if (!product || !Array.isArray(product.options)) return selected;

    product.options.forEach(function (_optionName, index) {
      selected[index + 1] = '';
    });

    return selected;
  }

  function resolveVariantFromSelectedOptions(product, selectedOptions) {
    if (!product || !Array.isArray(product.variants) || !selectedOptions) return null;

    return product.variants.find(function (variant) {
      return product.options.every(function (_optionName, index) {
        const position = index + 1;
        return String(variant[`option${position}`] || '') === String(selectedOptions[position] || '');
      });
    }) || null;
  }

  function isOptionValueSelectable(product, selectedOptions, optionPosition, optionValue) {
    if (!product || !Array.isArray(product.variants)) return false;

    return product.variants.some(function (variant) {
      if (!variant.available) return false;
      if (String(variant[`option${optionPosition}`] || '') !== String(optionValue || '')) return false;

      return product.options.every(function (_optionName, index) {
        const currentPosition = index + 1;
        if (currentPosition === optionPosition) return true;

        const selectedValue = selectedOptions[currentPosition];
        if (selectedValue == null || selectedValue === '') return true;

        return String(variant[`option${currentPosition}`] || '') === String(selectedValue || '');
      });
    });
  }

  function buildVariantSubTitle(product, variant, fallbackSubtitle) {
    if (!product || !variant) return fallbackSubtitle || '';

    const values = [];
    product.options.forEach(function (_optionName, index) {
      const value = variant[`option${index + 1}`];
      if (value != null && value !== '') {
        values.push(String(value));
      }
    });

    return values.join(' / ') || fallbackSubtitle || '';
  }

  function setBundleItemImage(imageEl, selectedVariant, customImage, product) {
    if (!imageEl) return;

    if (customImage && !String(customImage).includes('no-image')) {
      imageEl.src = customImage;
      imageEl.srcset = customImage;
      return;
    }

    const variantImage =
      selectedVariant?.featured_image?.src || null;

    const fallbackImage =
      product && ((product.featured_image && product.featured_image.src) || product.featured_image)
        ? ((product.featured_image && product.featured_image.src) || product.featured_image)
        : '';

    const finalImage = variantImage || fallbackImage;

    if (finalImage) {
      imageEl.src = finalImage;
      imageEl.srcset = finalImage;
    }
  }

  function setPriceContent(priceEl, compareEl, variant) {
    if (!priceEl || !compareEl) return;

    if (!variant) {
      priceEl.textContent = '';
      compareEl.textContent = '';
      priceEl.classList.remove('active');
      return;
    }

    priceEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price == null || Number(variant.compare_at_price) <= Number(variant.price)) {
      compareEl.textContent = '';
      priceEl.classList.remove('active');
    } else {
      compareEl.textContent = formatMoney(variant.compare_at_price);
      priceEl.classList.add('active');
    }
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;

    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(
          cents,
          window.theme?.moneyFormat || '${{amount}}'
        );
      }
    } catch (_error) {}

    try {
      const currency =
        window.Shopify?.currency?.active ||
        document.documentElement.getAttribute('data-currency') ||
        'USD';

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency
      }).format(amount);
    } catch (_error) {
      return '$' + amount.toFixed(2);
    }
  }

  function bindPopupOptionEvents() {
    if (!popupRoot) return;

    popupRoot.addEventListener('change', function (event) {
      const input = event.target;
      if (!input.matches('input[data-bundle-slot][data-option-position]')) return;

      const slot = input.getAttribute('data-bundle-slot');
      const optionPosition = Number(input.getAttribute('data-option-position'));
      const optionValue = input.getAttribute('data-option-value');

      if (!slot || !optionPosition) return;

      handleBundleOptionChange(slot, optionPosition, optionValue);
    });
  }

  function handleBundleOptionChange(slot, optionPosition, optionValue) {
    const itemState = state.bundleItems[slot];
    if (!itemState?.product || !itemState.mountedCard) return;

    itemState.selectedOptions[optionPosition] = optionValue;

    const exactVariant = resolveVariantFromSelectedOptions(itemState.product, itemState.selectedOptions);
    const fallbackVariant =
      exactVariant && exactVariant.available
        ? exactVariant
        : findClosestAvailableVariant(itemState.product, itemState.selectedOptions);

    if (fallbackVariant) {
      itemState.selectedOptions = getSelectedOptionsFromVariant(itemState.product, fallbackVariant);
      itemState.selectedVariantId = String(fallbackVariant.id);
    } else {
      itemState.selectedVariantId = null;
    }

    renderBundleProductCard(itemState);
    validateBundleState();
  }

  function findClosestAvailableVariant(product, selectedOptions) {
    if (!product || !Array.isArray(product.variants)) return null;

    let bestMatch = null;
    let bestScore = -1;

    product.variants.forEach(function (variant) {
      if (!variant.available) return;

      let score = 0;

      product.options.forEach(function (_optionName, index) {
        const position = index + 1;
        if (String(selectedOptions[position] || '') === String(variant[`option${position}`] || '')) {
          score += 1;
        }
      });

      if (score > bestScore) {
        bestScore = score;
        bestMatch = variant;
      }
    });

    return bestMatch;
  }

  function validateBundleState() {
    if (!popupRoot) return false;

    const firstVariant = getSelectedBundleVariant(state.bundleItems.first);
    const secondVariant = getSelectedBundleVariant(state.bundleItems.second);

    if (!state.variantData) {
      setBundleStatus('This bundle is not available for the selected product variant.', 'is-error');
      setBundleAtcDisabled(true);
      updateBundleAtcText();
      return false;
    }

    if (!firstVariant || !secondVariant) {
      setBundleStatus('Please select available variants for both bundle items.', 'is-info');
      setBundleAtcDisabled(true);
      updateBundleAtcText();
      return false;
    }

    if (!firstVariant.available || !secondVariant.available) {
      setBundleStatus('One selected variant is sold out.', 'is-error');
      setBundleAtcDisabled(true);
      updateBundleAtcText();
      return false;
    }

    setBundleStatus('', '');
    setBundleAtcDisabled(false);
    updateBundleAtcText();
    return true;
  }

  function getSelectedBundleVariant(itemState) {
    if (!itemState?.product || !itemState.selectedVariantId) return null;

    return itemState.product.variants.find(function (variant) {
      return String(variant.id) === String(itemState.selectedVariantId);
    }) || null;
  }

  function bindPopupAtc() {
    if (!popupRoot) return;

    popupRoot.addEventListener('click', function (event) {
      const button = event.target.closest('[data-bundle-atc]');
      if (!button) return;

      event.preventDefault();

      if (!validateBundleState()) return;
      addSelectedBundleItemsToCart();
    });
  }

  function addSelectedBundleItemsToCart() {
    const firstVariant = getSelectedBundleVariant(state.bundleItems.first);
    const secondVariant = getSelectedBundleVariant(state.bundleItems.second);

    if (!firstVariant || !secondVariant) {
      setBundleStatus('Please select available variants for both bundle items.', 'is-error');
      setBundleAtcDisabled(true);
      updateBundleAtcText();
      return;
    }

    const requestData = [
      { quantity: 1, id: firstVariant.id },
      { quantity: 1, id: secondVariant.id }
    ];

    setBundleAtcLoading(true);

    fetch('/cart/add.js?sections=cart-drawer', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify({ items: requestData })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to add bundle items to cart.');
        }
        return response.json();
      })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        const drawerSectionKey = data?.sections
          ? Object.keys(data.sections).find(function (key) {
              return key.includes('cart-drawer');
            })
          : null;

        const cartDrawerElement = document.querySelector('cart-drawer, cart-notification-drawer');

        if (cartDrawerElement && drawerSectionKey && data.sections[drawerSectionKey]) {
          const inner = cartDrawerElement.querySelector('.drawer__content, .cart-drawer, .drawer') || cartDrawerElement;
          inner.innerHTML = data.sections[drawerSectionKey];
        }

        closeBundlePopup();

        if (cartDrawerElement) {
          if (typeof cartDrawerElement.show === 'function') {
            cartDrawerElement.show();
          } else if (typeof cartDrawerElement.open === 'function') {
            cartDrawerElement.open();
          } else {
            cartDrawerElement.setAttribute('open', '');
          }
        }
      })
      .catch(function (error) {
        console.error(error);
        setBundleStatus('Bundle could not be added to cart right now.', 'is-error');
      })
      .finally(function () {
        setBundleAtcLoading(false);
        validateBundleState();
      });
  }

  function bindPopupOpenCloseEvents() {
    if (!popupRoot) return;

    els.popupOpenButton?.addEventListener('click', openBundlePopup);
    els.popupCloseButton?.addEventListener('click', closeBundlePopup);
  }

  function openBundlePopup() {
    if (!popupRoot) return;

    popupRoot.setAttribute('open', 'true');
    popupRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('my-body-noscroll-class');
  }

  function closeBundlePopup() {
    if (!popupRoot) return;

    popupRoot.setAttribute('open', 'false');
    popupRoot.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('my-body-noscroll-class');
  }

  function setBundleStatus(message, type) {
    if (!els.popupStatus) return;

    els.popupStatus.textContent = message || '';
    els.popupStatus.classList.remove('is-error', 'is-success', 'is-info');

    if (type) {
      els.popupStatus.classList.add(type);
    }
  }

  function setBundleAtcDisabled(disabled) {
    if (!els.popupAtcButton) return;

    els.popupAtcButton.disabled = !!disabled;
    els.popupAtcButton.classList.toggle('is-disabled', !!disabled);
    els.popupAtcButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function setBundleAtcLoading(isLoading) {
    if (!els.popupAtcButton) return;

    els.popupAtcButton.disabled = !!isLoading;
    els.popupAtcButton.classList.toggle('is-disabled', !!isLoading);
    els.popupAtcButton.setAttribute('aria-disabled', isLoading ? 'true' : 'false');

    if (isLoading) {
      els.popupAtcButton.dataset.originalText = els.popupAtcButton.textContent;
      els.popupAtcButton.textContent = 'Adding...';
    } else if (els.popupAtcButton.dataset.originalText) {
      els.popupAtcButton.textContent = els.popupAtcButton.dataset.originalText;
      delete els.popupAtcButton.dataset.originalText;
    }
  }

  function updateBundleAtcText() {
    if (!els.popupAtcButton) return;

    const firstVariant = getSelectedBundleVariant(state.bundleItems.first);
    const secondVariant = getSelectedBundleVariant(state.bundleItems.second);

    if (!firstVariant || !secondVariant || !firstVariant.available || !secondVariant.available) {
      els.popupAtcButton.textContent = 'Add to cart';
      return;
    }

    const totalPrice = Number(firstVariant.price || 0) + Number(secondVariant.price || 0);
    const formattedTotal = formatMoney(totalPrice);

    const currencyCode =
      window.Shopify?.currency?.active ||
      document.documentElement.getAttribute('data-currency') ||
      'USD';

    els.popupAtcButton.textContent = `Add to cart - ${formattedTotal} ${currencyCode}`;
  }

  function resetPopupContentToUnavailable(message) {
    if (!popupRoot) return;

    state.bundleItems.first = createInitialBundleItemState('first');
    state.bundleItems.second = createInitialBundleItemState('second');

    const fallbackMessage = message || 'This bundle is not available for the selected product variant.';
    const cards = popupRoot.querySelectorAll('[data-bundle-slot]');

    cards.forEach(function (card) {
      const optionsTarget = card.querySelector('[data-bundle-options]');
      const priceEl = card.querySelector('[data-bundle-price]');
      const compareEl = card.querySelector('[data-bundle-compare-price]');
      const subTitleEl = card.querySelector('[data-bundle-product-subtitle]');

      if (subTitleEl) subTitleEl.textContent = '';
      setPriceContent(priceEl, compareEl, null);
      setNoVariantState(optionsTarget, fallbackMessage);
    });

    setBundleStatus(fallbackMessage, 'is-error');
    setBundleAtcDisabled(true);
    updateBundleAtcText();
  }

  function setNoVariantState(target, message) {
    if (!target) return;
    target.innerHTML = `<div class="ed-no-variant-message">${escapeHtml(message)}</div>`;
  }

  function setNoVariantInlineMessage(target, message) {
    if (!target) return;

    const existing = target.querySelector('.ed-no-variant-message');
    if (existing) existing.remove();

    const messageEl = document.createElement('div');
    messageEl.className = 'ed-no-variant-message';
    messageEl.textContent = message;
    target.appendChild(messageEl);
  }

  function injectBundleEnhancementStyles() {
    if (document.getElementById('ed-bundle-enhancement-styles')) return;

    const style = document.createElement('style');
    style.id = 'ed-bundle-enhancement-styles';
    style.textContent = `
      .ed-bundle-invalid {
        outline: 2px solid #b42318;
        outline-offset: 6px;
        transition: outline-color 0.2s ease;
      }
    `;
    document.head.appendChild(style);
  }

  function slugify(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'value';
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
});
